module.exports = global["jQuery"] = require("-!E:\\leadto_project\\s塞防\\Skyfend\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");